import {SponsoredSignOff as ISponsoredSignOff} from "@proto/chatbot/v1alpha/chatbot"
import BotMessage from "./BotMessage"
import SponsoredShowcase from "./SponsoredShowcase"

interface IProps {
    content?: ISponsoredSignOff
}

const SponsoredSignOff = ({content}: IProps) => {
    if (!content) {
        return
    }

    const m = (
        <a href={content.url} target="site">
            {content.text}
        </a>
    )
    return (
        <div>
            <BotMessage key="so_1" message={m} />
            {/* <SponsoredShowcase content={content?.showcase} /> */}
        </div>
    )
}

export default SponsoredSignOff
